import { render, staticRenderFns } from "./SearchWord.vue?vue&type=template&id=b2550cbc&scoped=true&"
import script from "./SearchWord.vue?vue&type=script&lang=js&"
export * from "./SearchWord.vue?vue&type=script&lang=js&"
import style0 from "./SearchWord.vue?vue&type=style&index=0&id=b2550cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2550cbc",
  null
  
)

export default component.exports